module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payout record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "error-messages": _vm.selectedCampaignErrors,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Campaign Name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.clients,
      "search-input": _vm.searchClient,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Client",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchClient = $event
      },
      "update:search-input": function($event) {
        _vm.searchClient = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchClient))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.client),
      callback: function($$v) {
        _vm.$set(_vm.payout, "client", $$v)
      },
      expression: "payout.client"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Receiving Bank A/C No.",
      "placeholder": "Receiving Bank A/C No.(omit dashes)",
      "error-messages": _vm.bankNoErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankAccountNo),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankAccountNo", $$v)
      },
      expression: "payout.bankAccountNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Receiving A/C Name",
      "placeholder": "Receiving A/C Name.",
      "error-messages": _vm.receivingNameErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      }
    },
    model: {
      value: (_vm.payout.receivingName),
      callback: function($$v) {
        _vm.$set(_vm.payout, "receivingName", $$v)
      },
      expression: "payout.receivingName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Swift Code",
      "hide-details": "",
      "placeholder": "RABONL2U",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.bankSwiftCode),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankSwiftCode", $$v)
      },
      expression: "payout.bankSwiftCode"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.statuses,
      "hide-details": "auto",
      "label": "Status",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.status),
      callback: function($$v) {
        _vm.$set(_vm.payout, "status", $$v)
      },
      expression: "payout.status"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Instagram Handle",
      "hide-details": "auto",
      "error-messages": _vm.instagramHandleErrors,
      "placeholder": "Instagram Handle",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.instagramHandle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.instagramHandle.$touch()
      }
    },
    model: {
      value: (_vm.payout.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "instagramHandle", $$v)
      },
      expression: "payout.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.userCs,
      "min-height": "30px",
      "multiple": "",
      "item-text": "name",
      "hide-details": "auto",
      "dense": "",
      "search-input": _vm.searchCs,
      "label": "CS Name",
      "outlined": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchCs = $event
      },
      "update:search-input": function($event) {
        _vm.searchCs = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchCs))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.cs),
      callback: function($$v) {
        _vm.$set(_vm.payout, "cs", $$v)
      },
      expression: "payout.cs"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "BIB REF",
      "placeholder": "BK19010043050112",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.BIBREF),
      callback: function($$v) {
        _vm.$set(_vm.payout, "BIBREF", $$v)
      },
      expression: "payout.BIBREF"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "FT REF",
      "hide-details": "auto",
      "placeholder": "FT19010043050143",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.FTREF),
      callback: function($$v) {
        _vm.$set(_vm.payout, "FTREF", $$v)
      },
      expression: "payout.FTREF"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "REF",
      "hide-details": "auto",
      "placeholder": "KOBE-AN-KW",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.REF),
      callback: function($$v) {
        _vm.$set(_vm.payout, "REF", $$v)
      },
      expression: "payout.REF"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Billing Contact",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.billingContact),
      callback: function($$v) {
        _vm.$set(_vm.payout, "billingContact", $$v)
      },
      expression: "payout.billingContact"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "error-messages": _vm.amountErrors,
      "placeholder": "300",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Approval Date *",
            "prepend-inner-icon": "event",
            "outlined": "",
            "dense": "",
            "readonly": ""
          },
          model: {
            value: (_vm.payout.approvalDate),
            callback: function($$v) {
              _vm.$set(_vm.payout, "approvalDate", $$v)
            },
            expression: "payout.approvalDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.pickDate = false
      }
    },
    model: {
      value: (_vm.payout.approvalDate),
      callback: function($$v) {
        _vm.$set(_vm.payout, "approvalDate", $$v)
      },
      expression: "payout.approvalDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.$v.payout.$invalid,
      "text": ""
    },
    on: {
      "click": _vm.doAction
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e6005f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/CreatePayoutRecordModal.vue
// module id = 2181
// module chunks = 0